import { useSelector } from 'react-redux'
import { selectDetailMenuSite } from '@/redux/meta/selector'
import {
  useGetAllStoresQuery,
  useGetMenuQuery,
  useGetStoreItemAvailabilityQuery,
} from '@/services/oms'

const useGetMenuProducts = (skip?: boolean) => {
  const meta = useSelector(selectDetailMenuSite)

  const menuResp = useGetMenuQuery(
    {
      menuId: meta?.menu?.id as string,
      storeOrderId: meta?.storeOrderId as string,
      mode: meta?.mode as string,
    },
    {
      skip: !meta?.menu?.id || !meta?.mode || skip,
    }
  )

  useGetStoreItemAvailabilityQuery(meta?.menu?.id as string, {
    skip: !meta?.menu?.id || skip,
  })

  useGetAllStoresQuery(meta?.menu?.id as string, {
    skip: !meta?.menu?.id || skip,
  })

  return menuResp
}

export default useGetMenuProducts
